export const TOGGLE_BUTTON_CLASS_IDENTIFIER = '.js-kmcc-btn-toggle';



// WEBPACK FOOTER //
// ./vendor/kunstmaan/cookie-bundle/Resources/ui/js/config/toggleButton.config.js